import React, { useState, useEffect } from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { Nav, NavbarContainer, NavLogo, NavTextWrapper, NavText, NavImg, NavMenu, NavItem, NavLink, DropDownList, DropDownItem, DropDownItemL, DropDownContent, DropDownLink, MobileIcon, OpenIcon, IconText } from './NavbarElements';

const Navbar = ({ toggle, img1, alt1, productPDF }) => {
    const [scrollNav, setScrollNav] = useState(false);

	const changeNav = ()=> {
		if(window.scrollY >= 80) {
			setScrollNav(true)
		} else {
			setScrollNav(false)
		}
	}

	useEffect(() => {
		window.addEventListener('scroll', changeNav)
	}, [])

    const toggleHome = () => {
		scroll.scrollToTop();
	}

    return (
        <>
            <Nav scrollNav={scrollNav}>
                <NavbarContainer>
                    <NavTextWrapper>
                        <NavText>WORLDS ONLY CARRIER-GRADE OPTICAL WIRELESS COMMUNICATIONS</NavText>
                    </NavTextWrapper>
                    <NavLogo to='/' onClick={toggleHome}><NavImg src={img1} alt={alt1}/></NavLogo>
                    <MobileIcon onClick={toggle}>
                        <IconText>Menu</IconText><OpenIcon />
                    </MobileIcon>
                    <NavMenu>
                        <DropDownList>
                            <DropDownItem>Product</DropDownItem>
                            <DropDownContent>
                                <DropDownLink to={productPDF} target="_blank">Spec Sheet</DropDownLink>
                                <DropDownLink to='/rfq'>Get a Quote</DropDownLink>
                            </DropDownContent>
                        </DropDownList>
                        <NavItem>
                            <NavLink to='/tech'>Tech</NavLink> 
                        </NavItem>
                        <DropDownList>
                            <DropDownItem>News</DropDownItem> 
                                <DropDownContent>
                                    <DropDownLink to='/news'>Attochron News</DropDownLink>
                                    <DropDownLink to='/industry'>Industry News</DropDownLink>
                                </DropDownContent>
                        </DropDownList>
                        <DropDownList>
                            <DropDownItemL to='/about'>About Us</DropDownItemL> 
                                <DropDownContent>
                                    <DropDownLink to='/jobs'>Careers</DropDownLink>
                                    <DropDownLink to='/contact'>Contact Us</DropDownLink>
                                </DropDownContent>
                        </DropDownList>
                    </NavMenu>
                </NavbarContainer>
            </Nav>
            
        </>
    )
}

export default Navbar